<template>
  <div>
    <vs-card>
      <div :key="item" v-for="(value, item) in copyCount" :style="[{ padding: '5px' }, item % 10 == 0 || item == 0 ? { pageBreakBefore: 'always', marginTop: '75px' } : {}]">
        <div class="flex mb-4 content" style="display: flex; font-size: 6px; height: 100px">
          <div class="w-1/2 bg-grid-color-secondary h-12" :style="{ padding: '0px 10px 0px 10px' }">
            <div class="flex mb-4" style="display: flex">
              <div class="w-1/2 bg-grid-color-secondary h-12" style="width: 275px">
                <b>Product Name : </b>{{ (product && product.productLabel && product.productLabel.product_name) || (product && product.product_name) }}
                <br />
                <b>Terpenoid Potency : </b>{{ (product && product.productLabel && product.productLabel.terpenoidPotency) || '' }}
                <br />
                <b>Batch Number : </b>{{ (product && product.productLabel && product.productLabel.batchNumber) || '' }}
                <br />
                <b>Date Packaged : </b>{{ product | packagedDate }}
                <br />
                <b>Expiry Date : </b>{{ product | expiryDate }}
                <br />
                <b>CBD (% ): </b>{{ (product && product.productLabel && product.productLabel.cbd) || '' }}
                <br />
                <b>THC (% ): </b>{{ (product && product.productLabel && product.productLabel.thc) || '' }}
                <br />
                <b>License Number: </b>{{ supplier && supplier.omma_license_number }}
                <br />
                <b>Business Name : </b>{{ (supplier && supplier.business_name) || (supplier && supplier.username) }}
                <br />
                <b>Qty/Weight of Conents: </b>{{ (product && product.productLabel && product.productLabel.quantity_Or_weightOfContents) || '' }}
                <br />
                <b>THC Dosage /Unit(Mg): </b>{{ (product && product.productLabel && product.productLabel.THC_Dosage) || '' }}
                <br />
                <b>Caution: </b> Women should not use marijuana or medical marijuana during pregnancy because of the risk of health defects or while breastfeeding. Keep out of reach of children. For
                accidental ingestion call 1-800-222-1222 <br />
                <b>NB: </b> This product has been tested for contaminants <br />
              </div>
              <div class="w-1/2 bg-grid-color h-12" style="text-align: center; width: 175px">
                <img src="@/assets/images/product_label/label.png" class="logo" style="width: 150px; height: 90px" />
                <div class="flex mb-4" style="text-align: center">
                  <!-- <div class="w-1/3 bg-grid-color h-12" style="overflow: hidden">
                    <div class="images"><bar-code :options="options" :value="product.productLabel && product.productLabel.batchNumber" /></div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
          <div class="w-1/2 bg-grid-color h-12" v-if="parseInt(totalLabel / 2) != item" :style="{ padding: '0px 10px 0px 10px' }">
            <div class="flex mb-4" style="display: flex">
              <div class="w-1/2 bg-grid-color-secondary h-12" style="width: 275px">
                <b>Product Name : </b>{{ (product && product.productLabel && product.productLabel.product_name) || (product && product.product_name) }}
                <br />
                <b>Terpenoid Potency : </b>{{ (product && product.productLabel && product.productLabel.terpenoidPotency) || '' }}
                <br />
                <b>Batch Number : </b>{{ (product && product.productLabel && product.productLabel.batchNumber) || '' }}
                <br />
                <b>Date Packaged : </b>{{ product | packagedDate }}
                <br />
                <b>Expiry Date : </b>{{ product | expiryDate }}
                <br />
                <b>CBD (% ): </b>{{ (product && product.productLabel && product.productLabel.cbd) || '' }}
                <br />
                <b>THC (% ): </b>{{ (product && product.productLabel && product.productLabel.thc) || '' }}
                <br />
                <b>License Number: </b>{{ supplier && supplier.omma_license_number }}
                <br />
                <b>Business Name : </b>{{ (supplier && supplier.business_name) || (supplier && supplier.username) }}
                <br />
                <b>Qty/Weight of Conents: </b>{{ (product && product.productLabel && product.productLabel.quantity_Or_weightOfContents) || '' }}
                <br />
                <b>THC Dosage /Unit(Mg): </b>{{ (product && product.productLabel && product.productLabel.THC_Dosage) || '' }}
                <br />
                <b>Caution: </b> Women should not use marijuana or medical marijuana during pregnancy because of the risk of health defects or while breastfeeding. Keep out of reach of children. For
                accidental ingestion call 1-800-222-1222 <br />
                <b>NB: </b> This product has been tested for contaminants <br />
              </div>
              <div class="w-1/2 bg-grid-color h-12" style="text-align: center; width: 175px">
                <img src="@/assets/images/product_label/label.png" class="logo" style="width: 150px; height: 90px" />
                <div class="flex mb-4 cards" style="text-align: center">
                  <!-- <div class="w-1/2 bg-grid-color h-12" style="overflow: hidden">
                    <div class="images"><bar-code :options="options" :value="product.productLabel && product.productLabel.batchNumber" /></div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vs-card>
    <div v-html="html" />
  </div>
</template>
<script>
import moment from 'moment'
import BarCode from '@/components/utils/BarCode.vue'

export default {
  name: 'LabelSizeFourXOne',
  components: {
    BarCode
  },
  props: ['product', 'totalLabel', 'supplier'],
  data: () => ({
    options: {
      width: 1,
      height: 25,
      displayValue: false
    },
    html: `<style>
      .content {
        height:1.2in;
        page-break-inside:avoid;
      }
    </style>`
  }),

  computed: {
    copyCount() {
      return Array(Number(parseFloat(this.totalLabel / 2).toFixed(0))).fill(null)
    }
  },

  filters: {
    packagedDate(product) {
      if (product && product.productLabel && product.productLabel.packagedDate) {
        return moment(product && product.productLabel && product.productLabel.packagedDate).format('MM-DD-YYYY')
      }
      return ''
    },
    expiryDate(product) {
      if (product && product.productLabel && product.productLabel.expiryDate) {
        return moment(product && product.productLabel && product.productLabel.expiryDate).format('MM-DD-YYYY')
      }
      return ''
    }
  },

  watch: {
    product() {}
  }
}
</script>

<style lang="scss" scoped></style>
